module.exports = {
    borderRadius: {
        base: '16px',
        large: '26px',
    },
    colors: {
        // yA colors
        purple: '#653279',
        darkPurple: '#521866',
        lightPurple: '#7b458e',
        lightLightPurple: '#9870AA',
        yellow: '#F2A900',
        black: '#1C1C1B',
        // Other colors
        success: '#F2A900',
        error: '#dc2828',
        darkGrey: '#646464',
        lightGrey: '#dcdcdc',
        superLightGrey: '#eeeeee',
        transparent: 'transparent',
        white: '#ffffff',
        darkGreen: "#003C3C",
        lightGreen: "#00A397",
        red: "#AA3200"
    },
    headerHeight: '70px',
    contentMaxWidthExtra: '1440px',
    contentMaxWidth: '1150px',
    maxWidth: 1150,
    formPadding: {
        desktop: '40px',
        mobile: '20px',
    },
    outerPadding: '3.5vw',
    gap: {
        col: '4rem',
        row: '3.75rem',
    },
    baseSize: 16,
    breakpoints: {
        smallSmartphone: 320,
        smartphone: 380,
        bigSmartphone: 480,
        tablet: 768,
    },
    mediaQueries: {
        // Tablet and larger
        tabletMin: '@media only screen and (min-width: 768px)',
        // Only mobile
        mobileMax: '@media only screen and (max-width: 767px)',
        // Desktop and larger
        desktopMin: '@media only screen and (min-width: 1152px)',
    },
    spacing: {
        tiny: '0.5rem' /** 8px */,
        // (smaller is basesize, which is 16px)
        smaller: '1rem' /** 16px */,
        small: '1.5rem' /** 24px */,
        base: '2rem' /** 32px */,
        medium: '3.75rem' /** 60px */,
        large: '4rem' /** 64px */,
        xlarge: '6rem' /** 96px */,
        indent: '2.5rem', /** Indentation spacing. For example on headings */
    },
    menuBar: {
        height: '80px',
    },
};
